import { AuthorityMagazine } from '../../../src/components'
import Footers from '../../../src/components/Footer'
import Header from '../../../src/components/Header'
import { SEO } from '../../../src/components/components'

export default function AccessibilityPage() {
  return (
    <>
      <SEO
        title="Eric Poe | CEO of CURE Auto Insurance"
        description="Eric Poe, CEO of CURE Auto Insurance, shares his vision for inclusive leadership and how he’s looking to reshape the car insurance industry."
      />
      <Header />
      <div className="cure-inner-container">
        <AuthorityMagazine />
      </div>
      <Footers />
    </>
  )
}
